package com.arena_web.data.api

import com.arena_web.data.dto.AddressSuggestionDto
import com.arena_web.data.dto.PlaceAddressDto
import com.arena_web.data.http.ApiResponse
import com.arena_web.data.http.apiGet
import io.ktor.client.*

/**
 * Address autocomplete via the backend's Google Places proxy (`GeoRoute.kt`).
 * The Google key lives server-side only; requests ride the authenticated app
 * client. `session` is a client-generated random token spanning one typing
 * session plus the final [placeDetails] call — Google bills that as ONE
 * autocomplete session instead of per keystroke.
 *
 * A backend without a configured key returns an empty suggestion list — the
 * caller falls back to Nominatim (`searchAddress`).
 */
class PlacesApi(private val client: HttpClient) {

    suspend fun autocomplete(
        query: String,
        biasLat: Double?,
        biasLng: Double?,
        session: String?,
        /** "cities" restricts predictions to cities (profile City field —
         *  no place-details follow-up, so no session token either). */
        types: String? = null,
    ): ApiResponse<List<AddressSuggestionDto>> {
        val params = buildMap {
            put("query", query)
            biasLat?.let { put("lat", it.toString()) }
            biasLng?.let { put("lng", it.toString()) }
            session?.let { put("session", it) }
            types?.let { put("types", it) }
        }
        return client.apiGet("v1/geo/address-autocomplete", params)
    }

    suspend fun placeDetails(placeId: String, session: String?): ApiResponse<PlaceAddressDto> {
        val params = session?.let { mapOf("session" to it) } ?: emptyMap()
        return client.apiGet("v1/geo/address-place/$placeId", params)
    }
}
